import { render } from "./PhilosophyPage.vue?vue&type=template&id=041cb58a&scoped=true"
import script from "./PhilosophyPage.vue?vue&type=script&lang=js"
export * from "./PhilosophyPage.vue?vue&type=script&lang=js"

import "./PhilosophyPage.vue?vue&type=style&index=0&id=041cb58a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041cb58a"]])

export default __exports__